import React from 'react';
import store from './index';
export const Context = React.createContext(store);